(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('bakersSection', bakersSection);

    /* @ngInject */
    function bakersSection($sce) {
        var directive = {
            bindToController: true,
            templateUrl: 'bakers-section.tpl',
            controller: bakersSectionController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
            scope.vm.filterABCExpr = '';
            angular.forEach(scope.vm.data, function(v) {
                v.address = $sce.trustAsHtml(v.address);
            });
        }

    }

    /* @ngInject */
    function bakersSectionController ($scope) {
        $scope.inputABC = function(letter) {
            $scope.vm.filterABCExpr = letter;
            $scope.vm.filterTextExpr = '';
        };

        $scope.filterBoth = function(item) {
            var result =  true;
            if ($scope.vm.filterTextExpr) {
                result = new RegExp($scope.vm.filterTextExpr,'i').test(item.name) || new RegExp($scope.vm.filterTextExpr,'i').test(item.address);
            } else {
                result = new RegExp('^' + $scope.vm.filterABCExpr,'i').test(item.name);
            }
            return result;
        };

    }
})();